export enum BridgeInternalEvents {
  LINK_CLICK = 'fotoscape-link-click'
}
